import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoLocationOutline, IoTimeOutline } from 'react-icons/io5';
import MeetingStatusIndicator from './MeetingStatusIndicator';

const MeetingSearchContainer = ({ meeting }) => {
  const navigate = useNavigate();

  const handleMeetingClick = () => {
    navigate(`/app/meetings/${meeting.meetingId}`);
  };

  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const period = hours >= 12 ? '오후' : '오전';
    const displayHours = hours > 12 ? hours - 12 : hours === 0 ? 12 : hours;

    return `${month}/${day} ${period} ${displayHours}:${minutes.toString().padStart(2, '0')}`;
  };

  return (
    <div
      onClick={handleMeetingClick}
      className="py-4 px-4 border-b border-gray-300 active:bg-gray-50 cursor-pointer"
    >
      {/* 제목과 상태 */}
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-base font-medium text-gray-900">
          {meeting.title}
        </h3>
        <MeetingStatusIndicator status={meeting.status} />
      </div>

      {/* 시간과 장소 정보 */}
      <div className="space-y-1">
        <div className="flex items-center text-gray-600">
          <IoTimeOutline size={16} className="mr-2" />
          <span className="text-sm">
            {formatDateTime(meeting.scheduledAt)}
          </span>
        </div>
        <div className="flex items-center text-gray-600">
          <IoLocationOutline size={16} className="mr-2" />
          <span className="text-sm">
            {meeting.placeName}
            {meeting.isPartnerPlace && (
              <span className="ml-2 text-xs bg-blue-100 text-blue-600 px-1.5 py-0.5 rounded">
                상대방 선택
              </span>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MeetingSearchContainer;
